<!-- <div class="main-wrapper">
  <app-header></app-header>
  <div class="app-body position-relative">
      <app-sidebar></app-sidebar>
      <main class="main">
          <div class="row">
            <div class="col-md-12 all-sports user-account">
              <h3 class="quickHeader text-start ps-2"><i class="fa fa-user-circle-o"></i> {{userDetails?.user_name}}</h3>
              <div class="sidebar">
                <nav class="sidebar-nav">
                    <ul class="sidebar-menu" data-widget="tree">
                        <li>
                          <a (click)="info()">
                            <span>My Profile</span><span class="pull-right-container"><i class="fa fa-angle-right pull-right"></i></span>
                          </a>
                        </li>
                        <li>
                          <a (click)="rollComission()">
                            <span>Rolling Commision</span><span class="pull-right-container"><i class="fa fa-angle-right pull-right"></i></span>
                          </a>
                        </li>
                        <li>
                          <a (click)="statement()">
                            <span>Account Statement</span><span class="pull-right-container"><i class="fa fa-angle-right pull-right"></i></span>
                          </a>
                        </li>
                        <li>
                          <a [routerLink]="['/betHistory']">
                            <span>Bets History</span><span class="pull-right-container"><i class="fa fa-angle-right pull-right"></i></span>
                          </a>
                        </li>
                        <li>
                          <a (click)="profitLoss()">
                            <span>Profit & Loss</span><span class="pull-right-container"><i class="fa fa-angle-right pull-right"></i></span>
                          </a>
                        </li>
                        <li>
                          <a (click)="history()">
                            <span>Password History</span><span class="pull-right-container"><i class="fa fa-angle-right pull-right"></i></span>
                          </a>
                        </li>
                        <li>
                          <a (click)="activity()">
                            <span>Activity Log</span><span class="pull-right-container"><i class="fa fa-angle-right pull-right"></i></span>
                          </a>
                        </li>
                    </ul>
                </nav>
              </div>
              <a class="mbl-logout-btn" id="logout" (click)="logoutUser()">LOGOUT <i class="fa fa-sign-out ms-2"></i></a>
            </div>
          </div>
      </main>
      <app-right-sidebar></app-right-sidebar>               
  </div>
  <app-footer-main></app-footer-main>
</div> -->


<div class="app-body">
  <app-header></app-header>
    <div class="full-wrap">
      <div class="col-left">
        <!-- <app-sidebar></app-sidebar> -->
        <div class="sub_path">
          <div class="path">
            <a href="#path-pop" class="path-back">...</a>
            <ul>
              <li class="path-last"><a href="#">My Account</a></li>
            </ul>
          </div>
          <ul class="menu-list" data-widget="tree">
              <li>
                <a (click)="info()" class="select">
                  <span>My Profile</span><span class="pull-right-container"></span>
                </a>
              </li>
              <li>
                <a (click)="rollComission()">
                  <span>Rolling Commision</span><span class="pull-right-container"></span>
                </a>
              </li>
              <li>
                <a (click)="statement()">
                  <span>Account Statement</span><span class="pull-right-container"></span>
                </a>
              </li>
              <li>
                <a [routerLink]="['/betHistory']">
                  <span>Bets History</span><span class="pull-right-container"></span>
                </a>
              </li>
              <li>
                <a (click)="profitLoss()">
                  <span>Profit & Loss</span><span class="pull-right-container"></span>
                </a>
              </li>
              <li>
                <a (click)="history()">
                  <span>Password History</span><span class="pull-right-container"></span>
                </a>
              </li>
              <li>
                <a (click)="activity()">
                  <span>Activity Log</span><span class="pull-right-container"></span>
                </a>
              </li>
          </ul>
        </div>
      </div>

      <div id="centerColumn" class="col-center report d-none-mobile">
        <!-- Loading Wrap -->
        <div id="loading" class="loading-wrap" style="top: 100px; display: none;">
            <ul class="loading">
                <li><img src="assets/sky_img/loading40.gif"></li>
                <li>Loading...
                </li>
                <br>
                <li><span id="progress"></span></li>
            </ul>
        </div>
        
        <h2>Account Details</h2>
        <div class="event-left">
          <div class="profile-wrap">
            <h3>About You</h3>
            <dl>
              <dt>First Name</dt>
              <dd>{{userDetails?.user_name}}</dd>
              
              <dt>Last Name</dt>
              <dd>--</dd>
              
              <dt>Birthday</dt>
              <dd>--</dd>
              
              <dt>E-mail</dt>
              <dd>sffxf@fxt.co</dd>
              
              <dt>Password</dt>
              <dd>********************************
                <a href="#" class="favor-set">Edit</a>
              </dd>
            </dl>
          </div>
          <div class="profile-wrap">
            <h3>Address</h3>
            <dl>
              <dt>Address</dt>
              <dd>--</dd>
              
              <dt>Town/City</dt>
              <dd>--</dd>
              
              <dt>Country</dt>
              <dd>--</dd>
              
              <dt>Country/State</dt>
              <dd>--</dd>
              
              <dt>Postcode</dt>
              <dd>--</dd>
              
              <dt>Timezone</dt>
              <dd>IST</dd>
            </dl>
          </div>
        </div>
        <div class="event-right">
          <div class="profile-wrap">
            <h3>Contact Details</h3>
            <dl>
              <dt>Primary number</dt>
              <dd>--</dd>
            </dl>
          </div>
          
          <div class="profile-wrap">
            <h3>Setting</h3>
            <dl>
              <dt>Currency</dt>
              <dd>PTH</dd>
              
              <dt>Odds Format</dt>
              <dd>--</dd>
            </dl>
          </div>
          
          <div class="profile-wrap">
            <h3>Commission</h3>
            <dl>
              <dt>Comm charged</dt>
              <dd>2.0 %</dd>
            </dl>
          </div>
        </div>
      </div>

      <div class="d-lg-none">
        <div class="marquee-box">
          <h4>News</h4>
          <div class="marquee">
              <marquee>
                  <a><span>20 Dec 2022</span>Event :- India Women v Australia Women.... Market :- AUSW 6 Over Runs '43-44' (IST 19:07:48 - 19:08:39) , Fall of 2nd WKT AUSW Run Bhav '12.7.11' (IST 19:07:47 - 19:08:47) Bets Voided Because of Wrong Commentary...  Sorry for the Inconvenience Caused</a>
              </marquee>
          </div>
        </div>
        <div class="mian-wrap">
          <div class="path-wrap">
            <p class="account-id">
              <span>{{userDetails?.user_name}}</span>
              <span class="time-zone">GMT+5:30</span>
            </p>
          </div>
          <ul class="menu-list">
            <li>
              <a (click)="info()" target="_blank">
                <span>My Profile</span>
              </a>
            </li>
            <li>
              <a (click)="rollComission()" target="_blank">
                <span>Rolling Commision</span>
              </a>
            </li>
            <li>
              <a (click)="statement()" target="_blank">
                <span>Account Statement</span>
              </a>
            </li>
            <li>
              <a [routerLink]="['/betHistory']" target="_blank">
                <span>Bets History</span>
              </a>
            </li>
            <li>
              <a (click)="profitLoss()" target="_blank">
                <span>Profit & Loss</span>
              </a>
            </li>
            <li>
              <a (click)="history()" target="_blank">
                <span>Password History</span>
              </a>
            </li>
            <li>
              <a (click)="activity()" target="_blank">
                <span>Activity Log</span>
              </a>
            </li>
          </ul>
          <a id="logout" class="logout" (click)="logoutUser()">LOGOUT</a>
        </div>
      </div>
    </div>
  <app-footer-main></app-footer-main>
</div>